export const ALOHA_SCROLL_CONTAINER_ID = 'guest-site-aloha-scroll-container';
export const SIMPLE_SCROLL_CONTAINER_ID = 'guest-site-simple-scroll-container';
export const GUEST_SITE_START_PORTAL_ID = 'guest-site-start';
export const ACCOMMODATIONS_SLUG = 'accommodations';
export const CUSTOM_PAGE_PATH = 'page';

/**
 * Custom page slugs that should use the short route format (/:eventHandle/:slug)
 * instead of the standard custom page format (/:eventHandle/page/:slug).
 */
export const ALLOWLIST_CUSTOM_PAGE_SLUGS: ReadonlySet<string> = new Set([
  ACCOMMODATIONS_SLUG,
  'about',
  'schedule',
  'registration',
  'dress-code',
  'faqs',
  'things-to-do',
  'speakers',
  'vip',
  'weather',
]);
